import { request } from '@/utils/request.js'   // 客户列表
// 平台介绍列表
export function lists(data) {
    return request({
      url: '/admin/content.agreement/lists',
      method: 'post',
      data
    })
  }
// 内容详情
export function details(data) {
    return request({
      url: '/admin/content.agreement/details',
      method: 'post',
      data
    })
  }
// 内容编辑
export function renew(data) {
    return request({
      url: '/admin/content.agreement/renew',
      method: 'post',
      data
    })
  }
// 知识类型列表
export function typeLists(data) {
  return request({
    url: '/admin/content.article/typeLists',
    method: 'post',
    data
  })
}
// 知识库列表
export function repositorylists(data) {
  return request({
    url: '/admin/content.article/lists',
    method: 'post',
    data
  })
}
// 添加知识库
export function addKon(data) {
  return request({
    url: '/admin/content.article/add',
    method: 'post',
    data
  })
}
// 知识库详情
export function detailKon(data) {
  return request({
    url: 'admin/content.article/detail',
    method: 'post',
    data
  })
}
// 编辑知识库
export function editKon(data) {
  return request({
    url: 'admin/content.article/edit',
    method: 'post',
    data
  })
}
// 删除知识库
export function deleteKon(data) {
  return request({
    url: 'admin/content.article/delete',
    method: 'post',
    data
  })
}




// 内容管理

// 法律法规 -----------------------------------------------------------

// 法律法规列表
export function getLawRuleList(data) {
  return request({
    url: '/admin/content.lawsrule/list',
    method: 'post',
    data,
    showLoading: false,
  })
}

// 法律法规详情
export function getLawRuleDetail(data) {
  return request({
    url: '/admin/content.lawsrule/detail',
    method: 'post',
    data
  })
}

// 法律法规-添加
export function addLawRule(data) {
  return request({
    url: '/admin/content.lawsrule/add',
    method: 'post',
    data
  })
}

// 法律法规-删除
export function deleteLawRule(data) {
  return request({
    url: '/admin/content.lawsrule/del_lawsrule',
    method: 'post',
    data
  })
}

// 悬赏咨询 -----------------------------------------------------------

// 悬赏咨询-列表
export function getRewardList(data) {
  return request({
    url: '/admin/content/reward/list',
    method: 'post',
    data
  })
}

// 悬赏咨询-详情
export function getRewardDetail(data) {
  return request({
    url: '/admin/content/reward/detail',
    method: 'post',
    data
  })
}

// 悬赏咨询-操作
export function editRewardList(data) {
  return request({
    url: '/admin/content/reward/reward_edit',
    method: 'post',
    data
  })
}

// 文章管理 -----------------------------------------------------------

// 文章列表
export function getArticleList(data) {
  return request({
    url: '/admin/content.articles/list',
    method: 'post',
    data
  })
}

// 文章详情
export function getArticleDetail(data) {
  return request({
    url: '/admin/content.articles/detail',
    method: 'post',
    data
  })
}

// 文章编辑
export function AddOrEditArticle(data) {
  return request({
    url: '/admin/content.articles/add',
    method: 'post',
    data
  })
}

// 文章添加编辑
export function deleteArticle(data) {
  return request({
    url: '/admin/content.articles/del_article',
    method: 'post',
    data
  })
}

// 广告管理 -----------------------------------------------------------

// 广告列表 /admin/content/Ad/list
export function getAdList(data) {
  return request({
    url: '/admin/content/Ad/list',
    method: 'post',
    data
  })
}

// 编辑广告 /admin/content/Ad/add
export function editAd(data) {
  return request({
    url: '/admin/content/Ad/add',
    method: 'post',
    data
  })
}

// 获取广告位列表
export function getAdPosList(data) {
  return request({
    url: '/admin/content/Adpositon/list',
    method: 'post',
    data
  })
}

// 删除广告
export function delAd(data) {
  return request({
    url: '/admin/content/Ad/del_banner',
    method: 'post',
    data
  })
}

// 广告跳转类型
export function adQueryArticle(data) {
  return request({
    url: '/admin/content/ad/linkDetails',
    method: 'post',
    data
  })
}

// 平台介绍 -----------------------------------------------------------

// 平台介绍列表
export function getAgreementList(data) {
  return request({
    url: '/admin/content/agreement/lists',
    method: 'post',
    data
  })
}

// 平台介绍更新
export function editAgreement(data) {
  return request({
    url: '/admin/content/agreement/renew',
    method: 'post',
    data
  })
}

// 平台介绍详情
export function getAgreementDetail(data) {
  return request({
    url: '/admin/content/agreement/details',
    method: 'post',
    data
  })
}

// 首页动态管理 -----------------------------------------------------------

// 动态列表
export function getHomeNewsList(data) {
  return request({
    url: '/admin/content/dynamic/list',
    method: 'post',
    data
  })
}

// 添加动态
export function editHomeNews(data) {
  return request({
    url: '/admin/content/dynamic/add',
    method: 'post',
    data
  })
}

// 删除
export function deleteHomeNews(data) {
  return request({
    url: '/admin/content/dynamic/renew',
    method: 'post',
    data
  })
}

// 评价管理 -----------------------------------------------------------

// 评价列表
export function getEvaluateList(data) {
  return request({
    url: '/admin/content/comment/list',
    method: 'post',
    data
  })
}

// 评价详情
export function getEvaluateDetail(data) {
  return request({
    url: '/admin/content/comment/detail',
    method: 'post',
    data
  })
}

// 评价编辑
export function editEvaluate(data) {
  return request({
    url: '/admin/content/comment/add',
    method: 'post',
    data
  })
}

// 咨询客服评价列表
export function getServiceEvaluateList(data) {
  return request({
    url: '/admin/content.comment/lists',
    method: 'post',
    data
  })
}

// 意见反馈 -----------------------------------------------------------

// 获取意见反馈列表
export function getFeedbackList(data) {
  return request({
    url: '/admin/content/feedback/list',
    method: 'post',
    data
  })
}

// 获取意见反馈详情
export function getFeedbackDetail(data) {
  return request({
    url: '/admin/content/feedback/detail',
    method: 'post',
    data
  })
}

// 反馈分类列表
export function feedbackType(data) {
  return request({
    url: '/admin/content/feedback/type_list',
    method: 'post',
    data
  })
}

// 新增编辑反馈分类
export function addFeedbackType(data) {
  return request({
    url: '/admin/content/feedback/add',
    method: 'post',
    data,
    showLoading: false,
  })
}

// 删除反馈分类
export function delFeedbackType(data) {
  return request({
    url: '/admin/content/feedback/del_type',
    method: 'post',
    data
  })
}

// 批量处理标签
export function editLabelBatch(data) {
  return request({
    url: '/admin/label/batch',
    method: 'post',
    data,
    showLoading: false,
  })
}


// 获取标签
export function getLabelBatch(data) {
  return request({
    url: '/admin/label/list',
    method: 'post',
    data,
    showLoading: false,
  })
}

// 夜间工单记录列表
export function getNightAskList(data) {
  return request({
    url: '/admin/content.work_order/lists',
    method: 'post',
    data
  })
}
// 更新夜间工单记录
export function editNightAsk(data) {
  return request({
    url: '/admin/content.work_order/renew',
    method: 'post',
    data
  })
}
// 夜间工单推送消息
export function pushNightModel(data) {
  return request({
    url: '/admin/content.work_order/push',
    method: 'post',
    data
  })
}


  